let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("80DaC")).then(() => parcelRequire('877gu'));